import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Typography, CircularProgress, Button, Container } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { fetchWithTimeout } from "../../utils/fetchWithTimeout";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

const EmailVerificationPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying"); // verifying, success, error
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get("token");

      if (!token) {
        setStatus("error");
        setMessage("Invalid verification link. No token provided.");
        return;
      }

      try {
        const response = await fetchWithTimeout(
          `${BACKEND_URL}/email-verification/verify`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ token }),
          },
          30000
        );

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.detail || "Verification failed");
        }

        const data = await response.json();
        setStatus("success");
        setMessage(data.message || "Email verified successfully!");
        setEmail(data.email || "");
      } catch (err) {
        console.error("Email verification error:", err);
        setStatus("error");
        setMessage(err.message || "Failed to verify email. Please try again.");
      }
    };

    verifyEmail();
  }, [searchParams]);

  // const handleGoHome = () => {
  //   navigate("/");
  // };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          textAlign: "center",
          padding: 3,
        }}
      >
        {status === "verifying" && (
          <>
            <CircularProgress size={60} sx={{ mb: 3 }} />
            <Typography variant="h5" gutterBottom>
              Verifying your email...
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Please wait while we verify your email address.
            </Typography>
          </>
        )}

        {status === "success" && (
          <>
            <CheckCircleIcon
              sx={{ fontSize: 80, color: "success.main", mb: 2 }}
            />
            <Typography variant="h4" gutterBottom fontWeight="bold" sx={{ color: "#fff"}}>
              Email Verified!
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 1, color: "#fff"}}>
              {message}
            </Typography>
            {email && (
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3, color: "#fff" }}>
                Email: <strong>{email}</strong>
              </Typography>
            )}
            {/* <Button
              variant="contained"
              onClick={handleGoHome}
              sx={{
                backgroundColor: "#000",
                color: "#fff",
                padding: "10px 30px",
                borderRadius: "8px",
                "&:hover": { backgroundColor: "#333" },
              }}
            >
              Go to Home
            </Button> */}
          </>
        )}

        {status === "error" && (
          <>
            <ErrorIcon sx={{ fontSize: 80, color: "error.main", mb: 2 }} />
            <Typography variant="h4" gutterBottom fontWeight="bold" sx={{ color: "#fff" }}>
              Verification Failed
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3, color: "#fff" }}>
              {message}
            </Typography>
            {/* <Button
              variant="contained"
              onClick={handleGoHome}
              sx={{
                backgroundColor: "#000",
                color: "#fff",
                padding: "10px 30px",
                borderRadius: "8px",
                "&:hover": { backgroundColor: "#333" },
              }}
            >
              Go to Home
            </Button> */}
          </>
        )}
      </Box>
    </Container>
  );
};

export default EmailVerificationPage;

